import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'term',
  standalone: false
})
export class TermPipe implements PipeTransform {

  transform(days: number): string {
    if (days <= 0) return '0 días';

    const daysInYear = 360;
    const daysInMonth = 30;

    if (days % daysInYear === 0) {
      const years = days / daysInYear;
      return years === 1 ? '1 año' : `${years} años`;
    }

    if (days % daysInMonth === 0) {
      const months = days / daysInMonth;
      return months === 1 ? '1 mes' : `${months} meses`;
    }

    return `${days} días`;
  }

}

